import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Mike.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-white border border-navy/20 px-4 py-3.5 font-body text-navy focus:outline-none focus:border-brass focus:ring-1 focus:ring-brass";

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-navy px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-brass text-white flex items-center justify-center mx-auto"><Lock size={24} /></div>
          <h1 className="font-heading text-3xl text-white mt-6">CMS Access</h1>
          <p className="font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/50 mt-2">Mike Sidhu, Personal Real Estate Corporation · Listings Manager</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-paper p-8 space-y-5">
          <div>
            <label className="overline block mb-2">Email</label>
            <input data-testid="admin-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input data-testid="admin-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full bg-navy text-white py-3.5 hover:bg-brass transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
